<template>
  <div>
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()">
        <v-icon>{{ drawerIcon() }}</v-icon>
      </v-toolbar-side-icon>
      <v-layout align-center>
        <v-icon small>settings</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: false,
              text: 'Settings',
              disabled: true,
              to: '/administration',
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <headerProfile />
      </v-layout>

      <template v-slot:extension>
        <v-tabs
          v-model="tab"
          left
          color="transparent"
          slider-color="primary"
          height="36"
          show-arrows
        >
          <v-tab
            active-class="active-tab primary--text"
            :href="'#' + rootKey"
            v-for="(rootValue, rootKey) in adminData()"
            :key="rootKey"
            @click="resourceTab = ''"
          >
            <v-icon small>{{ rootValue.icon }}</v-icon>
            <span class="font-weight-bold pl-2">{{ rootKey }}</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item
        :value="rootKey"
        lazy
        v-for="(rootValue, rootKey, index) in adminData()"
        :key="rootKey"
      >
        <v-card flat>
          <v-tabs
            active-class="active-tab primary--text"
            left
            v-model="subtab[index]"
            color="theme_primary_lighten1"
            slider-color="primary"
            height="36"
            dense
          >
            <v-tab
              active-class="active-tab primary--text"
              class="white--text"
              :href="'#' + key"
              v-for="(value, key) in rootValue.tabs"
              :key="key"
            >
              <v-icon color="white" small>{{ value.icon }}</v-icon>
              <span class="font-weight-bold pl-2">{{ value.name }}</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="subtab[index]">
            <v-tab-item
              :value="key"
              lazy
              v-for="(value, key) in rootValue.tabs"
              :key="key"
            >
              <v-flex class="pt-2 px-4">
                <adminDataList
                  :v-if="value['collection']"
                  :collection="value['collection']"
                  :resourceName="key"
                  :resourceDisplayName="value.name"
                  :icon="value.icon"
                  :columnsArray="value['columnsArray']"
                />
              </v-flex>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import headerProfile from "../components/shared/headerProfile";
import adminDataList from "../components/administration/adminDataList";
import { mapGetters } from "vuex";

export default {
  components: {
    headerProfile,
    adminDataList,
  },
  computed: {
    ...mapGetters("commonStore", [
      "customerParameterGroups",
      "customerParameters",
      "supplier_types",
      "additionalInformations",
      "companyStatuses",
      "stepTemplates",
      "stepTemplateGroups",
      "emailTemplates",
      "expeditionFieldTemplates",
      "scoreCostTemplates",
      "countries",
      "country_groups",
      "cities",
      "ports",
      "shipments",
      "incoterms",
      "currencies",
      "paymentTerms",
      "products",
      "product_categories",
      "packaging_infos",
      "packagings",
      "users",
      "roles",
      "availableActionGroups",
      "pdfTemplates",
      "jobs",
      "signatures",
      "pdf_template_headers",
      "pdf_template_footers",
      "accountTypes",
      "languages",
      "email_attachment_templates",
      "doc_situations",
    ]),
  },
  data() {
    return {
      tab: "Companies",
      subtab: [
        "customer_parameter_groups",
        "step_templates",
        "countries",
        "shipments",
        "currencies",
        "products",
        "users",
      ],
    };
  },
  methods: {
    adminData() {
      return {
        Companies: {
          icon: "store",
          tabs: {
            customer_parameter_groups: {
              name: "Customer Parameter Groups",
              icon: "ballot",
              collection: this.customerParameterGroups,
              columnsArray: ["name", "order_index"],
            },
            customer_parameters: {
              name: "Customer Parameters",
              icon: "storage",
              collection: this.customerParameters,
              columnsArray: [
                "name",
                "order_index",
                "customer_parameter_group.name",
              ],
            },
            supplier_types: {
              name: "Supplier Types",
              icon: "local_offer",
              collection: this.supplier_types,
              columnsArray: ["name", "short_name"],
            },
            additional_informations: {
              name: "Additional Informations",
              icon: "list_alt",
              collection: this.additionalInformations,
              columnsArray: ["name"],
            },
            company_statuses: {
              name: "Company Statuses",
              icon: "business",
              collection: this.companyStatuses,
              columnsArray: ["name"],
            },
          },
        },
        Templates: {
          icon: "assignment",
          tabs: {
            step_templates: {
              name: "Step Templates",
              icon: "storage",
              collection: this.stepTemplates,
              columnsArray: [
                "name",
                "step_template_group.name",
                "order_index",
                "action_type",
                "customer_parameters.name",
              ],
            },
            step_template_groups: {
              name: "Step Template Groups",
              icon: "ballot",
              collection: this.stepTemplateGroups,
              columnsArray: ["name", "order_index"],
            },
            languages: {
              name: "Languages",
              icon: "chat_bubble",
              collection: this.languages,
              columnsArray: ["name", "code"],
            },
            email_templates: {
              name: "Email Templates",
              icon: "mail_outline",
              collection: this.emailTemplates,
              columnsArray: ["name", "language.name", "subject"],
            },
            signatures: {
              name: "Signatures",
              icon: "mail_outline",
              collection: this.signatures,
              columnsArray: ["name"],
            },
            email_attachment_templates: {
              name: "Email Attachment Templates",
              icon: "attach_file",
              collection: this.email_attachment_templates,
              columnsArray: [
                "name",
                "order_index",
                "must_merge",
                "email_template.name",
                "step_template.name",
                "customer_parameter.name",
              ],
            },
            pdf_templates: {
              name: "Pdf Templates",
              icon: "mdi-file-pdf",
              collection: this.pdfTemplates,
              columnsArray: ["name"],
            },
            pdf_template_headers: {
              name: "Pdf Template Headers",
              icon: "mdi-file-pdf",
              collection: this.pdf_template_headers,
              columnsArray: ["name"],
            },
            pdf_template_footers: {
              name: "Pdf Template Footers",
              icon: "mdi-file-pdf",
              collection: this.pdf_template_footers,
              columnsArray: ["name"],
            },
            expedition_field_templates: {
              name: "Expedition Field Templates",
              icon: "assignment",
              collection: this.expeditionFieldTemplates,
              columnsArray: ["name", "code"],
            },
            score_cost_templates: {
              name: "Score Cost Templates",
              icon: "list",
              collection: this.scoreCostTemplates,
              columnsArray: [
                "name",
                "shipment.name",
                "customer_parameter.name",
                "order_index",
                "calculation",
              ],
            },
          },
        },
        Locations: {
          icon: "public",
          tabs: {
            countries: {
              name: "Countries",
              icon: "storage",
              collection: this.countries,
              columnsArray: ["name", "iso_code"],
            },
            country_groups: {
              name: "Country Groups",
              icon: "ballot",
              collection: this.country_groups,
              columnsArray: ["name", "countries.count"],
            },
            cities: {
              name: "Cities",
              icon: "location_city",
              collection: this.cities,
              columnsArray: ["name", "country.name"],
            },
            ports: {
              name: "Ports",
              icon: "directions_boat",
              collection: this.ports,
              columnsArray: ["name", "country.name"],
            },
          },
        },
        Freight: {
          icon: "directions_boat",
          tabs: {
            shipments: {
              name: "Shipments",
              icon: "directions",
              collection: this.shipments,
              columnsArray: [
                "name",
                "reference_name",
                "icon",
                "has_vessel_name",
              ],
            },
            incoterms: {
              name: "Incoterms",
              icon: "event_note",
              collection: this.incoterms,
              columnsArray: ["name", "code"],
            },
            doc_situations: {
              name: "Doc situations",
              icon: "mdi-file-document",
              collection: this.doc_situations,
              columnsArray: ["name", "customer_parameters.name"],
            },
          },
        },
        Financial: {
          icon: "monetization_on",
          tabs: {
            currencies: {
              name: "Currencies",
              icon: "attach_money",
              collection: this.currencies,
              columnsArray: ["name", "code"],
            },
            payment_terms: {
              name: "Payment Terms",
              icon: "assignment",
              collection: this.paymentTerms,
              columnsArray: ["name"],
            },
            account_types: {
              name: "Account Types",
              icon: "assignment",
              collection: this.accountTypes,
              columnsArray: [
                "name",
                "use_for_product",
                "use_out_of_contract",
                "icon",
                "color",
              ],
            },
          },
        },
        Products: {
          icon: "shopping_cart",
          tabs: {
            product_categories: {
              name: "Product Categories",
              icon: "ballot",
              collection: this.product_categories,
              columnsArray: ["name", "products.count"],
            },
            products: {
              name: "Products",
              icon: "storage",
              collection: this.products,
              columnsArray: ["name", "product_category.name"],
            },
            packagings: {
              name: "Packagings",
              icon: "mdi-package-variant-closed",
              collection: this.packagings,
              columnsArray: ["name"],
            },
            packaging_infos: {
              name: "Packaging Infos",
              icon: "mdi-package-variant",
              collection: this.packaging_infos,
              columnsArray: ["name"],
            },
          },
        },
        "Human Resources": {
          icon: "people",
          tabs: {
            users: {
              name: "Users",
              icon: "people_outline",
              collection: this.users,
              columnsArray: [
                "first_name",
                "last_name",
                "job.name",
                "last_connection",
                "online",
              ],
            },
            jobs: {
              name: "Jobs",
              icon: "work",
              collection: this.jobs,
              columnsArray: ["name", "users.count"],
            },
            roles: {
              name: "Roles",
              icon: "security",
              collection: this.roles,
              columnsArray: ["name", "code", "users.count"],
            },
            available_action_groups: {
              name: "Available Action Groups",
              icon: "dns",
              collection: this.availableActionGroups,
              columnsArray: ["name", "available_actions.count"],
            },
          },
        },
      };
    },
  },
};
</script>
